import { render, staticRenderFns } from "./ReportBreakdown.vue?vue&type=template&id=2bd64fa9&scoped=true&"
import script from "./ReportBreakdown.vue?vue&type=script&lang=js&"
export * from "./ReportBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd64fa9",
  null
  
)

export default component.exports